export default __webpack_public_path__ + "58967406386d4eef6b3ee114651b0a8e.ttf";